import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"list\"><g><path d=\"M11,1.1C11,0.5,10.5,0,9.9,0H1.1C0.5,0,0,0.5,0,1.1v8.8C0,10.5,0.5,11,1.1,11h8.8c0.6,0,1.1-0.5,1.1-1.1V1.1z M9,9H2V2h7V9   z\" /><path d=\"M11,14.1c0-0.6-0.5-1.1-1.1-1.1H1.1C0.5,13,0,13.5,0,14.1v8.8C0,23.5,0.5,24,1.1,24h8.8c0.6,0,1.1-0.5,1.1-1.1V14.1z M9,22   H2v-7h7V22z\" /><path d=\"M24,7.1C24,6.5,23.5,6,22.9,6h-8.8C13.5,6,13,6.5,13,7.1v2.8c0,0.6,0.5,1.1,1.1,1.1h8.8c0.6,0,1.1-0.5,1.1-1.1V7.1z M23,10   h-9V7h9V10z\" /><path d=\"M24,1.1C24,0.5,23.5,0,22.9,0h-8.8C13.5,0,13,0.5,13,1.1v2.8C13,4.5,13.5,5,14.1,5h8.8C23.5,5,24,4.5,24,3.9V1.1z M23,4h-9   V1h9V4z\" /><path d=\"M24,20.1c0-0.6-0.5-1.1-1.1-1.1h-8.8c-0.6,0-1.1,0.5-1.1,1.1v2.8c0,0.6,0.5,1.1,1.1,1.1h8.8c0.6,0,1.1-0.5,1.1-1.1V20.1z    M23,23h-9v-3h9V23z\" /><path d=\"M24,14.1c0-0.6-0.5-1.1-1.1-1.1h-8.8c-0.6,0-1.1,0.5-1.1,1.1v2.8c0,0.6,0.5,1.1,1.1,1.1h8.8c0.6,0,1.1-0.5,1.1-1.1V14.1z    M23,17h-9v-3h9V17z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js!./resources/assets/icons/list.svg
// module id = 5HGL
// module chunks = 0